import flowApi from '../api/flowApi'

async function createProcess(userId, workspaceId, userName) {
    const config = { headers: { 'workspace': workspaceId } }
    const body = { "user": { "id": userId, "name": userName}}
    try {
        const createProcessReq = await flowApi.post(`/owned-processes/`, body, config)
        // console.log(`Created Process: `, createProcessReq.data)
        localStorage.setItem('flowData', JSON.stringify(createProcessReq.data))
        return createProcessReq.data
    } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.log(`response: `, error.response)
        // console.error(`error when try to create process: `, error)
    }
}

export default createProcess;